// extracted by mini-css-extract-plugin
export default {"notificationPopover":"j7IW8FCIpZ9RVdzoS2J0aQ==","innerPopover":"_3+VbFl-vSfzSqcRqSTGH0Q=="};